const Icons = {
  Ic_logo: require("../Assets/logo.png"),

};
export default Icons;
